import { Link } from "react-router-dom";
import React from "react";
import WithMainLayout from "../hocs/layouts/MainLayout";
import { useDocTitle } from "../utils/hooks";

const NotFound = () => {
  useDocTitle("No encontrado");

  return <div className="content-page-404">
  <div className="description-404">
    <div className="container-icon">
      <i className="icon icon-error"></i>
    </div>
    <h1>Error 404</h1>
    <p>¡Lo sentimos! La página que está buscando no se encuentra disponible o no ha sido creada. Favor de ir a la pantalla de inicio.</p>
    <Link to="/" className="btn btn-primary btn-large">Volver a página de inicio</Link>
  </div>
</div>;
}

export default WithMainLayout(NotFound, "No encontrado", false, false);
